export function defaultStringSelector(value) {
    if (value === undefined || value === null) {
        return null;
    }
    if (value[""] !== undefined) {
        return value[""];
    }
    // Return anything we found.
    const [result] = Object.values(value);
    return result ?? null;
}
export function createStringSelector(preferredLanguages) {
    return (value) => {
        if (value === undefined || value === null) {
            return null;
        }
        for (const language of preferredLanguages) {
            if (value[language] !== undefined && value[language] !== null) {
                return value[language];
            }
        }
        // Return anything we found.
        const [result] = Object.values(value);
        return result ?? null;
    };
}
//# sourceMappingURL=string-selector.js.map